"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
/* eslint-disable */
/* tslint:disable */
var React = tslib_1.__importStar(require("react"));
var CloseTickIcon = function (_a) {
    var size = _a.size, props = tslib_1.__rest(_a, ["size"]);
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "0 0 22 22", fill: "currentColor", width: size || '1em', height: size || '1em' }, props),
        React.createElement("path", { stroke: "currentColor", fill: "currentColor", d: "M9.996 9.29L.707 0 0 .707l9.29 9.29L0 19.285l.707.707 9.29-9.29 9.289 9.29.707-.707-9.29-9.29 9.29-9.289L19.286 0l-9.29 9.29z", transform: "translate(1 1)", strokeLinecap: "round", fillRule: "evenodd" })));
};
CloseTickIcon.displayName = 'CloseTickIcon';
exports.default = CloseTickIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=CloseTickIcon.js.map